import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useAuth } from "../components/AuthProvider";
import { getAuthRedirectDestination } from "../utils/authRedirect";
import SignupVideoCarousel from "../components/SignupVideoCarousel";
import GoogleOAuthButton from "../components/GoogleOAuthButton";
import EmailSignupForm from "../components/EmailSignupForm";
import newLogo from "../assets/new-logo.png";
import "./Signup.css";

// Video URLs for the carousel
const SIGNUP_VIDEOS = [
  {
    url: "https://stream.mux.com/vxdwKt1UTf4k9o8aqkneeEkM00kGncRDfPAA7CwztbfI.m3u8",
    poster: "",
    title: "Runaway",
    artist: "Ziggy Alberts"
  },
  {
    url: "https://stream.mux.com/dzEorpZt3oMo00TYN1nCTtswJ9pcr3a8V01C9qp201HYZg.m3u8",
    poster: "",
    title: "You're My (Visualizer)",
    artist: "Arima Ederra"
  },
  {
    url: "https://stream.mux.com/eMSxtnpWJ5nhuWHGQdndud4eAFYpPfk1VwCYXkpRTqg.m3u8",
    poster: "",
    title: "She's Leaving You",
    artist: "MJ Lenderman"
  }
];

function Signup() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      const destination = getAuthRedirectDestination(location);
      navigate(destination || "/home");
    } else {
      navigate("/" + (location.search || ""));
    }
  }, [navigate, location, isAuthenticated]);

  return (
    <div className="signup-page">
      <div className="signup-container">
        {/* Logo */}
        <img
          src={newLogo}
          alt="Vibe-Stream"
          className="signup-logo"
        />

        {/* Headline */}
        <h1 className="signup-headline">Discover & Enjoy Music Videos</h1>

        {/* Video Carousel */}
        <div className="signup-video-section">
          <SignupVideoCarousel videos={SIGNUP_VIDEOS} />
        </div>

        {/* Signup CTA Text */}
        <p className="signup-cta-text">
          Start streaming with a free 14-day Party Pass.
        </p>

        {/* Google OAuth Button */}
        <GoogleOAuthButton />

        {/* Divider */}
        <div className="signup-divider">
          <span>OR</span>
        </div>

        {/* Email Signup Form */}
        <EmailSignupForm />

        {/* Terms of Service Footer */}
        <div className="signup-terms">
          By signing in, you agree to our{" "}
          <Link to="/terms" target="_blank" rel="noopener noreferrer">
            Terms of Service
          </Link>
          .
        </div>

        {/* Version Number */}
        <div className="signup-version">v2.6.1</div>
      </div>
    </div>
  );
}

export default Signup;
